module.exports = __webpack_public_path__ + "img/brand-google.b5f00927.svg";